import { IconIds } from '../Icon'

export interface TabbarProps {
  titles: Array<TabData>
  onSelected: (index: number, titleText?: string) => void
  default: number
  type?: TabbarType
  hide?: boolean
  disabled?: boolean
  onLayout?: any
  onLayoutOnlyForPosition?: number
}

export enum TabbarType {
  default = 'default',
  highlights = 'highlights',
  recentPayments = 'recentPayments',
  profile = 'profile',
}

export interface TabData {
  title: string
  iconId?: IconIds
}
